import { useForm } from '@mantine/form';

import { isValidObjectId } from '@/utils';

type FormValues = {
  pageId: string;
  rules: string[];
};

export const useCloneProphetPageForm = () => {
  return useForm<FormValues>({
    initialValues: {
      pageId: '',
      rules: [],
    },

    validate: {
      rules: (v) => {
        if (!v || !v.length || v.some((ruleId) => !isValidObjectId(ruleId))) {
          return 'Правила не выбраны';
        }
      },
    },
  });
};
